import React from 'react';
import SessionInfo from '../../SessionInfo';

export default ({
    session,
    settings,
    isSessionRegistrationEnabled,
    me,
    event,
    eventUrls,
    showEmailLogin,
    sessionViewType
}) => {
    const numberOfLines = sessionViewType === 'sessionPage' ? 1 : 2;
    return <div className='session-dates margin-bottom-small font-size-14'>
        <SessionInfo
            session={session}
            settings={settings}
            shouldRenderStartDate={true}
            me={me}
            eventUrls={eventUrls}
            showEmailLogin={showEmailLogin}
            event={event}
            numberOfLines={numberOfLines}
        />
    </div>;
};
